import { DatosGenerales } from '../../../../../types/empresa';
import { EmpresaDatosGenerales } from './EmpresaDatosGenerales';
import { useState } from 'react';
import { EditDatosGenerales } from './EditDatosGenerales';

interface Props {
    empresaId: number;
    datosGenerales: DatosGenerales;
}

export function DatosGeneralesContainer({ datosGenerales, empresaId }: Props) {
    const [showEdit, setShowEdit] = useState(false);

    return (
        <div className="h-full overflow-auto min-h-full">

            {showEdit
            ? <EditDatosGenerales
                empresaId={empresaId}
                setShowEdit={setShowEdit}
                datosGenerales={datosGenerales}/>
            : <EmpresaDatosGenerales
                empresaId={empresaId}
                setShowEdit={setShowEdit}
                showEdit={showEdit}
                datosGenerales={datosGenerales}/>}
        </div>
    );
}
